"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const InputLabel_1 = require("../InputLabel");
const Typography_1 = require("@material-ui/core/Typography");
const InputBase_1 = require("@material-ui/core/InputBase");
exports.Input = (_a) => {
    var { label, placeholder, helpertext, name, id } = _a, rest = __rest(_a, ["label", "placeholder", "helpertext", "name", "id"]);
    return (React.createElement(React.Fragment, null,
        label && React.createElement(InputLabel_1.default, { label: label, id: id }),
        React.createElement(InputBase_1.default, Object.assign({ id: id, name: name, placeholder: placeholder }, rest)),
        helpertext && (React.createElement(Typography_1.default, { variant: "subtitle1", style: { fontSize: 12 } }, helpertext))));
};
//# sourceMappingURL=Input.js.map